var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTagEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.315 18.434C6.10461 18.4336 5.90405 18.3449 5.76225 18.1895C5.61783 18.0353 5.54607 17.8269 5.565 17.6165L5.74875 15.596L14.2372 7.1105L16.89 9.7625L8.40374 18.2472L6.38325 18.431C6.36 18.4332 6.33675 18.434 6.315 18.434ZM17.4195 9.23225L14.7675 6.58025L16.3582 4.9895C16.4989 4.84866 16.6898 4.76953 16.8889 4.76953C17.0879 4.76953 17.2788 4.84866 17.4195 4.9895L19.0102 6.58025C19.1511 6.72092 19.2302 6.91181 19.2302 7.11087C19.2302 7.30993 19.1511 7.50082 19.0102 7.6415L17.4202 9.2315L17.4195 9.23225Z",
    fill: "#2E3A59"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagEdit);
export default __webpack_public_path__ + "static/media/tagEdit.99b4b707.svg";
export { ForwardRef as ReactComponent };